var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import qs from 'qs';
import { IconButton, Tooltip, Checkbox } from '@mui/material';
import OriginalEditField from '../MaterialTable/EditField';
import { useUserColumns } from '../../hooks/useColumns';
import useFetch from '../../hooks/useFetch';
import { useRequest } from '../../hooks/requestHook';
import { useNotify } from '../../hooks/notificationHook';
import { user as api } from '../../api';
import { UsersIcon } from '../atoms/Icons';
import PageLayout from '../atoms/PageLayout';
import MaterialTable from '../MaterialTable';
import { getCurrentUser } from '../../localStorage';
var AdminUsersPage = function () {
    var t = useTranslation().t;
    var notify = useNotify();
    var location = useLocation();
    var navigate = useNavigate();
    var currentUser = getCurrentUser();
    var _a = React.useState(false), loading = _a[0], setLoading = _a[1];
    var getAll = useRequest(api.getAll);
    var updateUser = useRequest(api.updateUser);
    var deleteUser = useRequest(api.deleteUser);
    var query = qs.parse(location.search.slice(1));
    var userColumns = useUserColumns({
        orderBy: query.orderBy,
        orderDirection: query.orderDirection,
    });
    var columns = [
        userColumns.email,
        userColumns.name,
        userColumns.isCommunityManager,
    ];
    var handleClickNewUser = React.useCallback(function () {
        navigate('/admin/users/new');
    }, [navigate]);
    var handleUpdate = React.useCallback(function (user) { return __awaiter(void 0, void 0, void 0, function () {
        var data, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = {
                        id: user.id,
                        name: user.name,
                        is_community_manager: user.isCommunityManager,
                    };
                    setLoading(true);
                    return [4 /*yield*/, updateUser(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, notify, updateUser]);
    var handleDelete = React.useCallback(function (user) { return __awaiter(void 0, void 0, void 0, function () {
        var data, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    data = { id: user.id };
                    setLoading(true);
                    return [4 /*yield*/, deleteUser(data)];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        throw Error('response error');
                    notify('success', [t('messages.deleteSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [deleteUser]);
    var fetchUsers = useFetch({
        buildFilterParams: function (_query) {
            return {};
        },
        api: getAll,
    });
    var EditField = function (props) {
        switch (props.columnDef.field) {
            case 'email':
                return props.value;
            case 'isCommunityManager':
                return (React.createElement(Checkbox, __assign({}, props, { checked: props.value, onChange: function (e) { return props.onChange(e.target.checked); } })));
            default:
                return React.createElement(OriginalEditField, __assign({}, props));
        }
    };
    return (React.createElement(PageLayout, { title: t('pages.adminUsers.title'), actions: React.createElement(IconButton, { onClick: handleClickNewUser, size: "large" },
            React.createElement(Tooltip, { title: t('register') },
                React.createElement(UsersIcon, null))) },
        React.createElement(MaterialTable, { model: "user", isLoading: loading, columns: columns, data: fetchUsers, editable: {
                isEditHidden: function (user) { return user.id === currentUser.id; },
                isDeleteHidden: function (user) { return user.id === currentUser.id; },
                onRowUpdate: handleUpdate,
                onRowDelete: handleDelete,
            }, components: {
                EditField: EditField,
            }, options: { paging: true } })));
};
export default AdminUsersPage;
